import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "t1" }
const _hoisted_2 = { class: "t1-sub" }
const _hoisted_3 = { class: "t2" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "pay-btn-txt" }
const _hoisted_6 = { class: "del" }

import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {computed, reactive} from "vue";
import {Close, Right} from '@nutui/icons-vue'
import ScrollList from "@/views/editor/section/lib/ScrollList.vue";
import CountDownTxtCss from "@/views/editor/components/display/CountDownTxtCss.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SkuPddDpl',
  setup(__props) {


const editor = useRoute().meta.editor as AEditor;
const promotion = editor.biz.active.promotion
const products = computed(() => promotion?.products() ?? [])
const info = reactive({idx: 0})
console.log('...............................')

return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_nut_image = _resolveComponent("nut-image")!
  const _component_nut_tag = _resolveComponent("nut-tag")!
  const _component_nut_button = _resolveComponent("nut-button")!
  const _component_nut_popup = _resolveComponent("nut-popup")!

  return (_openBlock(), _createBlock(_component_nut_popup, {
    visible: "",
    position: "bottom",
    "z-index": 3,
    round: "",
    style: {"overflow":"hidden"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, {
        vertical: "",
        gap: "middle",
        justify: "space-between",
        class: "pop"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_flex, { class: "top" }, {
            default: _withCtx(() => [
              _createVNode(ScrollList, {
                list: Array.from({length:6}, (_, i) => i),
                direction: "top",
                "section-length": 1,
                interval: "3s"
              }, {
                item: _withCtx(({item}) => [
                  _createElementVNode("view", {
                    class: _normalizeClass(["item", (item as number)%2==0 ? 'red' : 'green'])
                  }, [
                    _createElementVNode("span", null, "优惠马上结束" + _toDisplayString(item), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["list"]),
              _createVNode(_unref(Close))
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            vertical: "",
            justify: "space-between",
            class: "header"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_flex, {
                class: "alert",
                align: "flex-end"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("text", { class: "t1" }, "大促优惠", -1),
                  _createElementVNode("text", { class: "desc" }, "官方大促 限时直降", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_a_flex, {
                class: "product",
                gap: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_nut_image, {
                    src: products.value[info.idx].thumbnail+'-sq.110'
                  }, null, 8, ["src"]),
                  _createVNode(_component_a_flex, {
                    vertical: "",
                    gap: "small",
                    class: "info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("view", _hoisted_1, [
                        _createTextVNode(" 最后3小时¥" + _toDisplayString(products.value[info.idx].price) + " ", 1),
                        _createElementVNode("view", _hoisted_2, "优惠前¥" + _toDisplayString(products.value[info.idx].origin_price), 1)
                      ]),
                      _createElementVNode("view", null, [
                        _createVNode(_component_nut_tag, {
                          plain: "",
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("即将恢复" + _toDisplayString(products.value[info.idx].origin_price) + "元", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("view", _hoisted_3, [
                        _createElementVNode("text", null, "已选：" + _toDisplayString(products.value[info.idx].name), 1)
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("view", { class: "t3" }, "同类畅销榜第1", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_flex, {
                vertical: "",
                gap: "small",
                class: "coupons"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            gap: "middle",
            justify: "space-between",
            align: "center",
            class: "coupons"
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("text", null, "优惠券", -1)),
              _createElementVNode("view", _hoisted_4, [
                _cache[2] || (_cache[2] = _createTextVNode(" 预热-22元，团长-22元 ", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("view", { class: "bracket" }, "(", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("svg", {
                  class: "icon-clock",
                  viewBox: "0 0 1024 1024",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "p-id": "3862",
                  width: "200",
                  height: "200"
                }, [
                  _createElementVNode("path", {
                    d: "M512.238933 185.105067c-189.781333 0-343.722667 154.282667-343.722666 343.722666 0 189.44 153.941333 343.381333 343.722666 343.381334 189.44 0 343.381333-153.941333 343.381334-343.381334 0-189.44-153.941333-343.722667-343.381334-343.722666z m117.077334 377.856h-117.418667c-18.773333 0-34.133333-15.36-34.133333-34.133334v-177.152c0-18.773333 15.36-34.133333 34.133333-34.133333 19.114667 0 34.133333 15.36 34.133333 34.133333v143.018667h83.285334c19.114667 0 34.133333 15.36 34.133333 34.133333s-15.018667 34.133333-34.133333 34.133334zM863.3344 313.890133l-103.799467-103.8336a34.133333 34.133333 0 1 1 48.264534-48.264533l103.799466 103.8336a34.133333 34.133333 0 1 1-48.264533 48.264533zM112.401067 313.890133a34.133333 34.133333 0 0 1 0-48.264533L216.200533 161.792a34.133333 34.133333 0 1 1 48.264534 48.264533L160.6656 313.890133a34.133333 34.133333 0 0 1-48.264533 0z",
                    "p-id": "3863",
                    fill: "#ff0000"
                  })
                ], -1)),
                _createVNode(CountDownTxtCss, {
                  "end-time": Date.now() + 600 * 1000
                }, null, 8, ["end-time"]),
                _cache[5] || (_cache[5] = _createElementVNode("view", { class: "bracket" }, ")", -1)),
                _createVNode(_unref(Right))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            vertical: "",
            class: "content"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("view", { class: "item" }, [
                _createElementVNode("text", { class: "label" }, "门店"),
                _createElementVNode("view", { class: "list" }, [
                  _createElementVNode("view", { class: "item on" }, [
                    _createElementVNode("text", null, [
                      _createTextVNode("【无刷电机顶配款】金属滤芯13件套/永磁暴吸 "),
                      _createElementVNode("text", { class: "price" }, "￥56.02")
                    ])
                  ]),
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, [
                      _createTextVNode("北京 "),
                      _createElementVNode("text", { class: "price" }, "￥56.02")
                    ])
                  ]),
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, "北京")
                  ])
                ])
              ], -1),
              _createElementVNode("view", { class: "item" }, [
                _createElementVNode("text", { class: "label" }, "门店"),
                _createElementVNode("view", { class: "list" }, [
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, [
                      _createTextVNode("【无刷电机顶配款】金属滤芯13件套/永磁暴吸 "),
                      _createElementVNode("text", { class: "price" }, "￥56.02")
                    ])
                  ]),
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, [
                      _createTextVNode("北京 "),
                      _createElementVNode("text", { class: "price" }, "￥56.02")
                    ])
                  ]),
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, "北京")
                  ])
                ])
              ], -1),
              _createElementVNode("view", { class: "item" }, [
                _createElementVNode("text", { class: "label" }, "门店"),
                _createElementVNode("view", { class: "list" }, [
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, [
                      _createTextVNode("【无刷电机顶配款】金属滤芯13件套/永磁暴吸 "),
                      _createElementVNode("text", { class: "price" }, "￥56.02")
                    ])
                  ]),
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, [
                      _createTextVNode("北京 "),
                      _createElementVNode("text", { class: "price" }, "￥56.02")
                    ])
                  ]),
                  _createElementVNode("view", { class: "item" }, [
                    _createElementVNode("text", null, "北京")
                  ])
                ])
              ], -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_nut_button, {
            class: "pay-btn",
            type: "primary",
            block: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("view", _hoisted_5, [
                _cache[8] || (_cache[8] = _createTextVNode(" 现在抢，仅 ", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("view", { class: "half" }, "¥", -1)),
                _cache[10] || (_cache[10] = _createTextVNode(" 34 ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("view", { class: "half" }, ".34", -1)),
                _createElementVNode("view", _hoisted_6, "¥" + _toDisplayString(products.value[info.idx].origin_price), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})